<template>
  <section class="admin-placeholder-page">
    <p class="admin-placeholder-page__code">404</p>
    <h1>{{ t('admin.notFound.title') }}</h1>
    <RouterLink to="/admin">{{ t('admin.notFound.back') }}</RouterLink>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
.admin-placeholder-page {
  padding: var(--admin-page-padding);
}

.admin-placeholder-page__code {
  margin: 0;
  color: var(--admin-color-primary);
  font-size: 48px;
  font-weight: 700;
}

.admin-placeholder-page h1 {
  margin: 8px 0 20px;
}

.admin-placeholder-page a {
  color: var(--admin-color-primary);
}
</style>
